import * as globals from '@wandb/weave/common/css/globals.styles';
import {TargetBlank} from '@wandb/weave/common/util/links';
import {Icon} from '@wandb/weave/components/Icon';
import styled, {css} from 'styled-components';

export const TableOfContents = styled.div<{selected?: boolean}>`
  display: flex;
  flex-direction: column;
  ${props =>
    props.selected &&
    css`
      background: ${globals.THEME.statusInfoBg};
    `}
`;

export const NoHeadingMessage = styled.div`
  color: ${globals.THEME.textTertiary};
  line-height: 1.8;
`;

export const LearnMoreLink = styled(TargetBlank)`
  color: ${globals.THEME.textSecondary};
  text-decoration: underline;
  :hover {
    text-decoration: underline;
  }
`;

export const Anchor = styled.a<{level: number}>`
  color: ${globals.THEME.textSecondary};
  text-decoration: underline;
  text-decoration-thickness: 0.5px;
  font-size: 16px;
  font-family: Source Serif Pro;
  line-height: 1.8;
  padding-left: ${props => (props.level - 1) * 20}px;
  :hover {
    background: ${globals.THEME.bgHover};
    color: ${globals.THEME.textSecondary};
    text-decoration: underline;
    text-decoration-thickness: 0.5px;
  }
`;

export const ConfigIcon = styled(Icon).attrs({name: 'settings'})`
  position: absolute;
  z-index: 1;
  top: 6px;
  right: 40px;
  cursor: pointer;
`;

export const HeaderSelect = styled.div`
  position: absolute;
  top: 2px;
  right: 34px;
  width: 152px;
`;
